export const HEADERS = ['Manager', 'Active from', 'Active to', 'Action'];
